export default "__VITE_ASSET__C$cX_$Nn__"